import { StackGrid } from "@styleguide";
import { type Control, useWatch } from "react-hook-form";
import type { IModalActionForm, IModalActionResolver, TModalAction } from "../../logics/types";
import { ModalActionFormApply } from "./apply";
import { ModalActionFormEndOfContract } from "./endOfContract";
import { ModalActionFormJobSituation } from "./jobSituation";
import { ModalActionFormNextFollowUp } from "./nextFollowUp";

export interface IModalActionFormJobFollowUpProps {
  control: Control<IModalActionForm, void, IModalActionResolver>;
  action?: TModalAction;
}

export const ModalActionFormJobFollowUp = ({ control, action }: IModalActionFormJobFollowUpProps) => {
  const actionType = useWatch({ control, name: "type" });

  if (actionType?.value !== "job-follow-up") {
    return null;
  }

  return (
    <>
      <StackGrid perLine={{ tablet: 2 }} rowGap={2} columnGap={2} strict>
        <ModalActionFormApply control={control} action={action} />
        <ModalActionFormJobSituation control={control} />
        <ModalActionFormEndOfContract control={control} />
      </StackGrid>
      <ModalActionFormNextFollowUp control={control} />
    </>
  );
};
